import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {PlacesAutocompletePickedAddress} from '@mandae/ng-utils/google-places';
import {TextFormats} from '@mandae/ng-utils/mask';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {BaseDialog} from '../../../base-dialog';
import { FloatLabelType, MatDialogRef } from '@angular/material';
import { AddressAutocompletePickedAddress } from '../../../forms/components/address-autocomplete/address-autocomplete.component';
import {AddressValidatorsService} from '../../../services/address-validators.service';

@Component({
  selector: 'mandae-profile-address-form',
  templateUrl: './address-form.component.html',
  styleUrls: ['./address-form.component.scss']
})
export class AddressFormComponent extends BaseDialog<AddressFormComponent> implements OnInit {
  public form: FormGroup;
  public cepMask = TextFormats.cepMask;

  public address: AddressAutocompletePickedAddress = null;

  @Input() floatLabel: FloatLabelType = 'always';
  @Input() title: string;
  @Input() submitLabel: string;
  @Output() submit = new EventEmitter<FormGroup>();

  constructor(
    dialogRef: MatDialogRef<AddressFormComponent>) {

    super(dialogRef);

    this.form = new FormGroup({
      name: new FormControl('', [ Validators.required ]),
      sender: new FormControl('', [ Validators.required ]),
      postalCode: new FormControl('', [ Validators.required]),
      street: new FormControl('', [ Validators.required ]),
      number: new FormControl('', [ Validators.required ]),
      district: new FormControl('', [ Validators.required ]),
      complement: new FormControl(''),
      city: new FormControl('', [ Validators.required ]),
      state: new FormControl('', [ Validators.required, AddressValidatorsService.forbiddenState() ]),
      hasDedicatedCollectArea: new FormControl(false),
      collectDedicatedArea: new FormControl(''),
    }, {
      updateOn: 'change'
    });
  }

  ngOnInit() {
  }

  setFormAddress(address: AddressAutocompletePickedAddress) {
    this.address = address;
    this.form.patchValue(address);
  }

  async handleSubmit() {
    if (!this.form.valid) {
      return;
    }
    this.submit.emit(this.form);
  }
}
